module.exports = __webpack_public_path__ + "media/soundtrack.af3ac4af.mp3";